const COMPANY_LOCAL_STORAGE = 'IJOB'
export const TOKEN_KEY = `@${ COMPANY_LOCAL_STORAGE }USER-Token`;
export const USER_KEY = `${ COMPANY_LOCAL_STORAGE }USER-OBJ`;
export const INACTIVEJOBER_KEY = `@${ COMPANY_LOCAL_STORAGE }USER-EMAIL`

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUser = () => localStorage.getItem(USER_KEY);

export const login = token => {
  localStorage.setItem(TOKEN_KEY, token);
}

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
}

export const SetUser = token => {
  localStorage.setItem(USER_KEY, token);
}

export const DeleteUser = () => {
  localStorage.removeItem(USER_KEY);
}

export const SetInactiveJober = (token) => {
  localStorage.setItem(INACTIVEJOBER_KEY, token);
}